<template>
  <!-- Register Component -->
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-account-plus</v-icon>
        <h1 class="page-title">Register</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12">
          <v-text-field
            label="Username"
            prepend-icon="mdi-account-circle"
            v-model="user.userName"
            required
            :rules="userNameRules"
          />
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            label="Password"
            v-model="user.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            required
            :rules="passwordRules"
            @click:append="showPassword = !showPassword"
          />
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            label="Confirm Password"
            v-model="user.confirmPassword"
            :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPasswordConfirm ? 'text' : 'password'"
            required
            :rules="passwordRules"
            @click:append="showPasswordConfirm = !showPasswordConfirm"
          />
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            label="Email"
            prepend-icon="mdi-at"
            v-model="user.email"
          />
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12">
          <v-text-field
            prepend-icon="mdi-card-account-phone"
            label="Phone"
            v-model="user.phoneNumber"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn outlined :disabled="!valid" @click="onRegister"
          >Register</v-btn
        >
      </v-row>
    </v-form>
    <div>
      <statusalert ref="alert"></statusalert>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js'
import router from '@/router/index.js'
import AccountService from '@/services/api/AccountService.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Login',
  components: {
    statusalert
  },
  store: store,
  router: router,
  data: () => ({
    showPassword: false,
    showPasswordConfirm: false,
    user: {
      userName: '',
      password: '',
      confirmPassword: '',
      email: '',
      phoneNumber: ''
    },
    passwordRules: [v => !!v || 'Password is required'],
    userNameRules: [v => !!v || 'Username is required'],
    result: {},
    valid: false
  }),
  methods: {
    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    },
    onRegister() {
      AccountService.register(this.user)
        .then(result => {
          this.result = {
            isValid: true,
            statusCode: result.status,
            errors: ['You are registered']
          }
        })
        .catch(error => {
          console.log(error)
          this.result = {
            isValid: false,
            statusCode: 404,
            errors: ['Registration failed']
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.displayAlert()
        })
    }
  }
}
</script>
